import React, {Component} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';

import ArtifactRateDrawer from "../reviews/ArtifactRateDrawer";

const styles = theme => ({
    paper: {
        width: '100%',
        height: '100%',
    },
});

class ArtifactDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    handleClickOpen = () => {
        this.setState({open: true});
    };

    handleClose = () => {
        this.setState({open: false});
    };

    render() {
        return (
            <div>
                <Button color='secondary' onClick={this.handleClickOpen}>View Artifact</Button>
                <Dialog
                    fullScreen={false}
                    scroll='paper'
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="responsive-dialog-title"
                    maxWidth={false}
                    classes={{
                        paper: this.props.classes.paper,
                    }}
                >
                    <DialogTitle id="responsive-dialog-title">{this.props.title}</DialogTitle>
                    <DialogContent>
                        {this.props.children}
                    </DialogContent>
                    <DialogActions>
                        <ArtifactRateDrawer color="secondary" isReviewed={this.props.isReviewed}
                                            artifactId={this.props.submission.canvas_submission_id}/>
                        <Button onClick={this.handleClose} color="secondary" autoFocus>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

}

export default withStyles(styles)(ArtifactDialog);
